import React from 'react';
import { AlertTriangle, ArrowUpRight, BrainCircuit, ShieldAlert, Sparkles } from 'lucide-react';

import AIConfidenceIndicator from './AIConfidenceIndicator';

const iconByType = {
  risk: ShieldAlert,
  payroll: AlertTriangle,
  compliance: ShieldAlert,
  attrition: BrainCircuit,
  engagement: Sparkles,
  hiring: ArrowUpRight,
};

const badgeBySeverity = {
  critical: 'bg-rose-500/15 text-rose-300 border border-rose-500/20',
  high: 'bg-orange-500/15 text-orange-300 border border-orange-500/20',
  medium: 'bg-amber-500/15 text-amber-300 border border-amber-500/20',
  low: 'bg-sky-500/15 text-sky-300 border border-sky-500/20',
};

const AIInsightCard = ({ insight, variant = 'dark' }) => {
  const Icon = iconByType[insight?.insight_type] || Sparkles;
  const isLight = variant === 'light';

  return (
    <div className={isLight ? 'animate-slide-up rounded-2xl border border-border bg-card p-5 text-foreground shadow-sm' : 'animate-slide-up rounded-2xl border border-slate-700/80 bg-slate-950/90 p-5 text-slate-100 shadow-[0_16px_50px_rgba(2,6,23,0.3)] backdrop-blur-sm'}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className={isLight ? 'rounded-xl border border-primary/20 bg-primary/10 p-2.5' : 'rounded-xl border border-cyan-400/20 bg-cyan-400/10 p-2.5'}>
            <Icon className={`h-4 w-4 ${isLight ? 'text-primary' : 'text-cyan-200'}`} />
          </div>
          <div>
            <p className={`text-sm font-semibold ${isLight ? 'text-foreground' : 'text-slate-50'}`}>{insight?.title}</p>
            <p className={`mt-1 text-xs ${isLight ? 'text-muted-foreground' : 'text-slate-300'}`}>{insight?.region || insight?.department || 'AI Signal'}</p>
          </div>
        </div>
        <span className={`rounded-full px-2.5 py-1 text-[11px] font-medium capitalize ${badgeBySeverity[insight?.severity] || badgeBySeverity.medium}`}>
          {insight?.severity || 'medium'}
        </span>
      </div>
      <p className={`mt-4 text-sm leading-6 ${isLight ? 'text-foreground' : 'text-slate-200'}`}>{insight?.summary}</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        <div className={isLight ? 'rounded-xl border border-border bg-muted p-3' : 'rounded-xl border border-slate-700/80 bg-slate-800/70 p-3'}>
          <p className={`text-[11px] uppercase tracking-[0.18em] ${isLight ? 'text-muted-foreground' : 'text-slate-300'}`}>Risk Score</p>
          <p className={`mt-2 text-2xl font-semibold ${isLight ? 'text-foreground' : 'text-slate-50'}`}>{Number(insight?.risk_score || 0).toFixed(1)}</p>
        </div>
        <div className={isLight ? 'rounded-xl border border-border bg-muted p-3' : 'rounded-xl border border-slate-700/80 bg-slate-800/70 p-3'}>
          <AIConfidenceIndicator value={insight?.confidence_score} variant={variant} />
        </div>
      </div>
    </div>
  );
};

export default AIInsightCard;
